import { REGIONS } from '~constants/region';
import i18n from '@/i18n';

export default {
  data() {
    return {
      useNullableRegion: true,
    };
  },
  computed: {
    regionsItems() {
      const items = [];
      if (this.useNullableRegion) {
        items.push({
          text: i18n.t('global.filter.statuses.all'),
          value: null,
        });
      }
      Object.keys(REGIONS)
        .forEach(key => {
          if (key === 'defaultRegionText') {
            return true;
          }
          items.push({
            text: i18n.t(`global.filter.regions.${REGIONS[key]}`),
            value: REGIONS[key],
          });
        });
      return items;
    },
  },
};
